<template>
  <div class="aboutus" id="ground">
    <el-row>
      <el-col class="ground_l">
        <!--<div class="ground-title">Profile</div>-->
        <div class="aboutGroup-left-content">
          <h2>集团概况</h2>
          <div class="underline"></div>
          <pre class="detail">{{basic.introduce}}</pre>
        </div>
      </el-col>
      <el-col class="ground_r">
        <div class="top-box">
          <h2>企业宣传视频</h2>
          <p></p>
        </div>
        <div class="about_video">
          <video-player :options="playerOptions" class="vjs-custom-skin" :playsinline="true"></video-player>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      playerOptions: {
        height: "320",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster:
          "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg" //视频播放前放的照片，可自己调整
      },
      basic: {}
    };
  },
  created() {
    this.basic = this.$cache.get("aboutConfig");
  },
  watch: {
    basic(now) {
      // console.log(now);
      this.playerOptions.sources = [
        {
          src: now.video
        }
      ];
    }
  }
};
</script>
<style lang="less" scoped>
.aboutus {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  .ground_l {
    width: 629px;
    position: relative;
    padding: 63px 48px 47px 50px;
    .ground-title {
      position: absolute;
      right: 0;
      top: 0;
      width: 151px;
      height: 151px;
      line-height: 151px;
      background: #f2f2f2;
      font-size: 20px;
      font-weight: 500;
      color: #c0c0c0;
      text-align: center;
    }
    .aboutGroup-left-content {
      h2 {
        font-size: 30px;
        font-weight: 500;
        color: #333333;
      }
      .underline {
        width: 24px;
        height: 2px;
        background: #e60616;
        margin: 22px 0 24px 0;
      }
      .detail {
        font-size: 14px;
        font-weight: 400;
        color: #555555;
        line-height: 24px;
        white-space: pre-line;
        word-break: break-all;
      }
    }
  }
  .ground_r {
    width: 571px;
    .top-box {
      background: -webkit-linear-gradient(
        #494c53,
        #232529
      ); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(#494c53, #232529); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(#494c53, #232529); /* Firefox 3.6 - 15 */
      background: linear-gradient(#494c53, #232529); /* 标准的语法 */
      height: 228px;
      h2 {
        font-size: 24px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        padding-top: 77px;
      }
      p {
        width: 34px;
        height: 2px;
        background: #fff;
        margin: 48px auto 0 auto;
      }
    }
    .about_video {
      .vjs-poster {
        background-size: 100% 100%;
      }
    }
  }
}
</style>


